import { NTSReflection } from '@nts/std/src/lib/utility';
import { NotString } from '../types';

const VIEW_MODEL_TYPE_META_DATA_IDENTIFICATION_KEY = 'viewModelTypeDecoratorMetaDataKey';

export function ViewModelTypeDecorator<T>(viewModelType: NotString<T>) {
    return (target: any) => {
        Reflect.defineMetadata(VIEW_MODEL_TYPE_META_DATA_IDENTIFICATION_KEY, viewModelType, target);
    };
}

export class ViewModelTypeInspector {

    static META_DATA_KEY = VIEW_MODEL_TYPE_META_DATA_IDENTIFICATION_KEY;
    static DECORATOR_NAME = '@ViewModelTypeDecorator';

    static isApplied(subject: any): boolean {
        return NTSReflection.hasClassMetadata(
            VIEW_MODEL_TYPE_META_DATA_IDENTIFICATION_KEY, subject);
    }

    static getValue(subject: any): any {
        return NTSReflection.getClassMetadata(
            VIEW_MODEL_TYPE_META_DATA_IDENTIFICATION_KEY, subject);
    }
}
